import { useEffect, useState } from "react";
import { api, API } from "@/api";
import { Heart, Send } from "lucide-react";

export default function PopularPieces() {
  const [scope, setScope] = useState("event");
  const [rows, setRows] = useState(null);

  useEffect(() => {
    api.get(`/exhibitor/analytics/popular-products?scope=${scope}`).then(({ data }) => setRows(data)).catch(() => setRows(false));
  }, [scope]);

  if (!rows) return null;
  const max = Math.max(1, ...rows.map((r) => r.hearts));
  const tab = (k, label) => (
    <button onClick={() => setScope(k)} className={`text-[11px] px-2.5 py-1 rounded-full ${scope === k ? "btn-gold" : "glass text-slate-400"}`} data-testid={`popular-scope-${k}`}>{label}</button>
  );

  return (
    <div className="mt-8" data-testid="popular-pieces">
      <div className="flex items-center justify-between">
        <h2 className="font-display text-2xl gold-text">Popular Pieces</h2>
        <div className="flex gap-1.5">{tab("event", "This edition")}{tab("all", "All time")}</div>
      </div>
      <p className="text-xs text-slate-400 mt-1">Products visitors hearted most in your catalogues. Counts are anonymous; names appear only in leads when a visitor shares.</p>
      {rows.length === 0 ? (
        <div className="glass rounded-2xl p-6 text-center mt-3 text-sm text-slate-400" data-testid="popular-empty">No hearts yet. Share your catalogues to see what visitors love.</div>
      ) : (
        <div className="space-y-2 mt-3">
          {rows.map((r, i) => (
            <div key={r.product_id} className="glass rounded-2xl p-3 flex items-center gap-3" data-testid={`popular-row-${r.product_id}`}>
              <span className="font-display text-lg gold-text w-5 text-center">{i + 1}</span>
              <img src={`${API}/files/${r.image}`} alt="" className="h-12 w-12 rounded-xl object-cover" />
              <div className="flex-1 min-w-0">
                <div className="text-sm text-slate-100 truncate">{r.name}</div>
                <div className="h-1.5 rounded-full bg-amber-500/10 mt-1.5 overflow-hidden"><div className="h-full bg-rose-400 rounded-full" style={{ width: `${(r.hearts / max) * 100}%` }} /></div>
              </div>
              <div className="text-right shrink-0">
                <div className="text-sm text-slate-100 flex items-center gap-1 justify-end" data-testid={`popular-hearts-${r.product_id}`}><Heart size={13} className="text-rose-500" fill="currentColor" /> {r.hearts}</div>
                <div className="text-[10px] text-slate-500 flex items-center gap-1 justify-end"><Send size={10} /> {r.shared} shared</div>
              </div>
            </div>
          ))}
        </div>
      )}
    </div>
  );
}
